import { useEffect, useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { Wrapper, CtaButton } from "../../reusable";
import { IsMobile } from "../isMobile/isMobile";
import styles from "./styles.module.scss";
import responsiveStyles from "./responsive-styles.module.scss";
import mfnLogo from "../../../assets/mfnlogo.png";
import { Shield } from "lucide-react";

function Header() {
  const [displayMenu, setDisplayMenu] = useState<Boolean>(false);
  const { token } = useParams();
  const navigate = useNavigate();

  const scrollToFaqs = () => {
    setDisplayMenu(false);
    let faqs = document.getElementsByClassName("faq-elem");
    if (faqs.length > 0) {
      faqs[0].scrollIntoView({
        behavior: "smooth",
        block: "end",
        inline: "nearest",
      });
    } else {
      console.log("could not find the FAQS");
      navigate("/#faqs");
      const faqs = document.getElementsByClassName("faq-elem");
      if (faqs.length > 0) {
        faqs[0].scrollIntoView({
          behavior: "smooth",
          block: "end",
          inline: "nearest",
        });
      }
    }
  };

  const toggleMenu = () => {
    setDisplayMenu(!displayMenu);
  };

  const handleMenuClick = () => {
    setDisplayMenu(false);
  };

  const LogoSection = () => (
    <div
      className={`${styles.logo} ${responsiveStyles.logo} ${styles.centerLogo}`}
    >
      <Shield size={28} color="#2c3e50" />
      <span
        style={{
          marginLeft: "8px",
          fontSize: "18px",
          fontWeight: "600",
          letterSpacing: "0.5px",
        }}
      >
        <span style={{ color: "#2563eb" }}>Med</span>
        <span style={{ color: "#2c3e50" }}>Watch</span>
      </span>
    </div>
  );

  const NavigationLinks = () => (
    <nav>
      <ul>
        <li>
          <Link onClick={handleMenuClick} to={"/"}>
            About
          </Link>
        </li>
        <li>
          <a onClick={scrollToFaqs}>FAQs</a>
        </li>
        <li>
          <Link onClick={handleMenuClick} to={"/contact"}>
            Contact
          </Link>
        </li>
      </ul>
    </nav>
  );

  const RightNavigation = () => (
    <nav>
      <ul>
        <li>
          <CtaButton text="Start Claim" />
        </li>
      </ul>
    </nav>
  );

  const MobileMenu = () => (
    <>
      <div
        className={`${styles.menuButton} ${responsiveStyles.menuButton}`}
        onClick={toggleMenu}
      >
        <span></span>
      </div>
      <div
        className={`${displayMenu ? responsiveStyles.displayMenu : ""} ${
          styles.menuContainer
        } ${responsiveStyles.menuContainer}`}
      >
        <div className={`${styles.menu} ${responsiveStyles.menu}`}>
          <nav>
            <ul>
              <li>
                <Link onClick={handleMenuClick} to={"/claim/start"}>
                  Start Claim
                </Link>
              </li>
              <li>
                <Link onClick={handleMenuClick} to={"/"}>
                  About
                </Link>
              </li>
              <li>
                <a onClick={scrollToFaqs}>FAQs</a>
              </li>
              <li>
                <Link onClick={handleMenuClick} to={"/contact"}>
                  Contact
                </Link>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </>
  );

  const HeaderContent = () => {
    const showFullHeader = window.location.pathname.includes("/claim");

    if (showFullHeader) {
      return (
        <div
          className={`${styles.innerHeader} ${responsiveStyles.innerHeader}`}
        >
          {IsMobile() ? (
            <>
              <MobileMenu />
            </>
          ) : (
            <>
              <NavigationLinks />
              <LogoSection />
              <RightNavigation />
            </>
          )}
        </div>
      );
    }

    return (
      <div className={`${styles.innerHeader} ${responsiveStyles.innerHeader}`}>
        <LogoSection />
      </div>
    );
  };

  return (
    <header className={`${styles.header} ${responsiveStyles.header}`}>
      <Wrapper>
        <HeaderContent />
      </Wrapper>
    </header>
  );
}

export default Header;
